import SEOMeta from '@/components/feature/SEOMeta';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import CategoriesSection from './components/CategoriesSection';
import PopularSection from './components/PopularSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

const HomePage = () => {
  const homeSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '极速高清 - 在线观看高清视频首页',
    description: '极速高清在线观看平台首页，提供电影、电视剧、综艺、纪录片等海量高清视频内容',
    url: 'https://popvideos.github.io',
    isPartOf: {
      '@type': 'WebSite',
      name: '极速高清',
      url: 'https://popvideos.github.io',
    },
    about: {
      '@type': 'Organization',
      name: '极速高清',
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '极速高清在线观看需要下载安装吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '不需要。极速高清是纯网页端的在线观看平台，打开浏览器即可观看，无需下载任何软件或插件。',
        },
      },
      {
        '@type': 'Question',
        name: '支持哪些设备在线观看？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '极速高清支持手机、平板、笔记本电脑和台式电脑等多种设备在线观看。',
        },
      },
      {
        '@type': 'Question',
        name: '在线观看的画质最高支持多少？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '极速高清最高支持4K超清画质在线观看，同时提供多档画质选择。',
        },
      },
      {
        '@type': 'Question',
        name: '在线观看会消耗多少流量？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '流量消耗取决于所选画质。建议在WiFi环境下选择高画质，移动数据下选择标清模式。',
        },
      },
      {
        '@type': 'Question',
        name: '需要注册才能在线观看吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '部分免费内容无需注册即可在线观看。注册后可享受高清画质、无广告等更多权益。',
        },
      },
    ],
  };

  return (
    <>
      <SEOMeta
        title="极速高清 - 在线观看高清视频，随时随地畅享精彩内容"
        description="极速高清在线观看平台，无需下载，支持手机、平板、电脑多端同步。海量高清影视、综艺、纪录片随时播放，超低延迟、超清画质，注册即可免费在线观看。"
        keywords="在线观看,免费在线观看高清视频,在线观看电影电视剧,手机在线观看,无广告在线观看,在线观看4K超清,在线观看不限速"
        canonicalUrl="https://popvideos.github.io"
        schemaData={[homeSchema, faqSchema]}
      />

      <Navbar />

      <main>
        <article>
          <HeroSection />
          <FeaturesSection />
          <CategoriesSection />
          <PopularSection />
          <FAQSection />
          <CTASection />
        </article>
      </main>

      <Footer />
    </>
  );
};

export default HomePage;